(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(49730);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CompanyNameFooter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function CompanyNameFooter(param) {
    let { required =false  } = param;
    return required ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        p: 2,
        sx: {
            textAlign: "center",
            background: "white"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            variant: "smallText",
            component: "p",
            sx: {
                textTransform: "capitalize"
            },
            children: "venetto technologies private limited"
        })
    }) : null;
}


/***/ }),

/***/ 49730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(21519);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 2 modules
var List = __webpack_require__(91416);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./components/CurationCards/FeaturedCurationCard.js
var FeaturedCurationCard = __webpack_require__(18149);
// EXTERNAL MODULE: ./components/ProductCategory/CategoryList.js
var CategoryList = __webpack_require__(39858);
// EXTERNAL MODULE: ./layout/footer.js + 4 modules
var footer = __webpack_require__(48341);
// EXTERNAL MODULE: ./layout/header.js
var header = __webpack_require__(89980);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(47212);
// EXTERNAL MODULE: ./node_modules/localforage/dist/localforage.js
var localforage = __webpack_require__(69483);
var localforage_default = /*#__PURE__*/__webpack_require__.n(localforage);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utility/AxoisConfig.js + 41 modules
var AxoisConfig = __webpack_require__(71287);
;// CONCATENATED MODULE: ./service/home.js

const getDetails = async (token)=>{
    let headers = (0,AxoisConfig/* setHeader */.Ec)(token);
    let res = await AxoisConfig/* axiosInstance.get */.be.get("/api/home-details", {
        headers
    });
    return res;
};
const getLogedInUserDetails = async (token)=>{
    let headers = (0,AxoisConfig/* setHeader */.Ec)(token);
    let res = await AxoisConfig/* axiosInstance.get */.be.get("/api/home-details-load-more", {
        headers
    });
    return res;
};
const getCurations = async function(token) {
    let page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    let headers = (0,AxoisConfig/* setHeader */.Ec)(token);
    const res = await AxoisConfig/* axiosInstance.get */.be.get("api/curation/", {
        params: {
            page: page,
            page_size: 5
        },
        headers: headers
    });
    // console.log(res);
    return res;
};

// EXTERNAL MODULE: ./components/Head/GeneralHead.js
var GeneralHead = __webpack_require__(94231);
// EXTERNAL MODULE: ./components/Home/PlayOffCard.js
var PlayOffCard = __webpack_require__(99779);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@mui/material/ImageListItem/ImageListItem.js + 2 modules
var ImageListItem = __webpack_require__(60066);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js
var Box_Box = __webpack_require__(18377);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/ProductCategory/Playoff.js





const PlayoffCircle = (param)=>{
    let { playoff  } = param;
    let router = (0,next_router.useRouter)();
    const handleClick = ()=>{
        router.push("/playoff/".concat(playoff.slug, "/curations"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        onClick: handleClick,
        sx: {
            width: "100px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageListItem/* default */.Z, {
                sx: {
                    borderRadius: "50%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        width: 98,
                        height: 98
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: playoff.image,
                        alt: playoff.title,
                        width: 98,
                        height: 98
                    })
                })
            }, playoff.img),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                pt: 1,
                sx: {
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                    fontSize: "14px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    title: playoff.title,
                    children: playoff.title
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ProductCategory/PlayoffList.js



const PlayoffList = (param)=>{
    let { playoffList  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
        direction: "row",
        component: Stack/* default */.Z,
        spacing: 2,
        sx: {
            overflowX: "scroll",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
                width: 0
            }
        },
        children: playoffList.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PlayoffCircle, {
                playoff: item
            }, "playoff-circle-".concat(i)))
    });
};

// EXTERNAL MODULE: ./components/auth/Index.js + 10 modules
var Index = __webpack_require__(30521);
// EXTERNAL MODULE: ./service/Curation.js
var Curation = __webpack_require__(64473);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./components/common/ScorllContainer.js
var ScorllContainer = __webpack_require__(59570);
// EXTERNAL MODULE: ./service/products.js
var service_products = __webpack_require__(37766);
// EXTERNAL MODULE: ./node_modules/animate.css/animate.min.css
var animate_min = __webpack_require__(78413);
// EXTERNAL MODULE: ./node_modules/react-animation-on-scroll/dist/esm/index.js + 2 modules
var esm = __webpack_require__(77735);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/esm/index.esm.js + 2 modules
var index_esm = __webpack_require__(56467);
// EXTERNAL MODULE: ./components/HomeGrapeOfficialCard/HomeGrapeOfficailCard.js
var HomeGrapeOfficailCard = __webpack_require__(54936);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/swr/core/dist/index.mjs + 1 modules
var dist = __webpack_require__(59734);
// EXTERNAL MODULE: ./node_modules/@moxy/next-router-scroll/es/index.js + 4 modules
var es = __webpack_require__(26899);
// EXTERNAL MODULE: ./context/ScrollRestorationContext.js
var ScrollRestorationContext = __webpack_require__(42341);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./styles/card.js
var card = __webpack_require__(60130);
;// CONCATENATED MODULE: ./components/Skeletons/GapeList/GrapeListSkeleton.js




function GrapeListSkeleton() {
    const style = card/* cardStyle */.M;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        sx: {
            ...style.card,
            marginBottom: 2,
            boxShadow: "0px 4px 10px -6px rgba(0, 0, 0, 0.12)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "text",
                    sx: {
                        fontSize: "1rem"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    columnSpacing: "1px",
                    borderRadius: 2,
                    sx: {
                        overflow: "hidden",
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rounded",
                                height: 120
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rounded",
                                height: 120
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rounded",
                                height: 120
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rounded",
                                height: 120
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1.5,
                    mt: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            animation: "wave",
                            variant: "circular",
                            width: 25,
                            height: 25
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "text",
                            sx: {
                                fontSize: "1rem"
                            },
                            width: "50%"
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var GapeList_GrapeListSkeleton = (GrapeListSkeleton);

// EXTERNAL MODULE: ./components/Skeletons/ActivePlayoffSkeleton/ActivePlayoffSkeleton.js
var ActivePlayoffSkeleton = __webpack_require__(93200);
// EXTERNAL MODULE: ./components/Skeletons/CurationCardSkeleton/CurationCardSkeleton.js
var CurationCardSkeleton = __webpack_require__(5629);
// EXTERNAL MODULE: ./components/Skeletons/Screens/HomeScreenSkeleton.js
var HomeScreenSkeleton = __webpack_require__(15080);
// EXTERNAL MODULE: ./components/Skeletons/ProductCardSkeleton/ProductCardSkeleton.js
var ProductCardSkeleton = __webpack_require__(28190);
// EXTERNAL MODULE: ./layout/CompanyNameFooter.js
var CompanyNameFooter = __webpack_require__(66107);
// EXTERNAL MODULE: ./components/Product/ProductCard.js + 1 modules
var ProductCard = __webpack_require__(95407);
// EXTERNAL MODULE: ./components/Product/CurationDrawer.js + 1 modules
var CurationDrawer = __webpack_require__(39298);
// EXTERNAL MODULE: ./context/ScrollContext.js
var ScrollContext = __webpack_require__(79854);
;// CONCATENATED MODULE: ./pages/index.js














// import Tour from 'reactour'
























const Tour = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5383).then(__webpack_require__.bind(__webpack_require__, 85383)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(85383)
            ]
    },
    ssr: false
});
const Home = (param)=>{
    let { token  } = param;
    var _persistentList_products;
    const { data: session , status  } = (0,next_auth_react.useSession)();
    const fetcher = async (url)=>await getDetails(token).then((res)=>res.data);
    const { data , error , isLoading  } = (0,dist/* default */.ZP)("homepage_index", fetcher);
    // const { active_playoff, featured_curations: featuredCurationData = [] } =
    // 	data;
    const [active_playoff, setActive_playoff] = (0,react.useState)();
    const router = (0,next_router.useRouter)();
    const [showLoadingScreen, setShowLoadingScreen] = (0,react.useState)(true);
    const [showProductTour, setShowProductTour] = (0,react.useState)(false);
    const [curations, setCurations] = (0,react.useState)([]);
    const [featured_curations, setFeatured_curations] = (0,react.useState)([]);
    const [categories, setCategories] = (0,react.useState)([]);
    const [curated_playoffs, setCurated_playoffs] = (0,react.useState)([]);
    const [playoffs, setPlayoffs] = (0,react.useState)([]);
    const [grapeList, setGrapeList] = (0,react.useState)([]);
    const [authOpen, setAuthOpen] = (0,react.useState)(false);
    const [persistentList, setPersistentList] = (0,react.useState)([]);
    const [products, setProducts] = (0,react.useState)([]);
    const [animationSeen, setAnimationSeen] = (0,react.useState)(false);
    const [open, setOpen] = (0,react.useState)(false);
    const [curationsCount, setCurationsCount] = (0,react.useState)(null);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0
    });
    const [isAuthenticated, setIsAuthenticated] = (0,react.useState)(false);
    const { updateScroll  } = (0,es/* useRouterScroll */.lP)();
    // useEffect(() => {
    // 	setIsUpdated(true)
    // }, [status]);
    // const {scrollContainerRef} = scrollContextApi
    const { pageDetail , scrollContainerRef , setPageDetail  } = (0,react.useContext)(ScrollContext/* ScrollContext */.$);
    (0,react.useEffect)(()=>{
        const func = async ()=>{
            if (status !== "loading") {
                setIsAuthenticated(status === "authenticated");
                if (pageDetail) {
                    if (pageDetail.isTrayOpen) {
                        console.log(pageDetail.traydetail.curationCount);
                        setCurationsCount(pageDetail.traydetail.curationCount);
                    }
                    window.scrollTo({
                        top: pageDetail.scrollTo,
                        behavior: "auto"
                    });
                }
                let res = await getLogedInUserDetails(session);
                const { categories , curated_playoffs , featured_curations , playoffs , grapeList , persistentList  } = res.data;
                setCategories(categories);
                setCurated_playoffs(curated_playoffs);
                setFeatured_curations(featured_curations);
                setPlayoffs(playoffs);
                setGrapeList(grapeList);
                setPersistentList(persistentList);
                setProducts(persistentList === null || persistentList === void 0 ? void 0 : persistentList.products);
                setShowLoadingScreen(false);
            // if (pageDetail && scrollContainerRef.current) {
            // 	scrollContainerRef.current.scroll({
            // 		top: pageDetail.scrollTo,
            // 		behavior: "auto",
            // 	});
            // }
            }
        };
        func();
    }, [
        session,
        scrollContainerRef,
        isLoading
    ]);
    const closeProductTour = ()=>{
        setShowProductTour(false);
    };
    const checkSelectedCategories = async ()=>{
        let categories_exist = await localforage_default().getItem("set_categories");
        categories_exist = JSON.parse(categories_exist);
        if (!categories_exist) {
            router.push("/welcome");
        } else {
            setShowSplashScreen(false);
        }
    };
    // const getLoadDetails = async () => {
    // 	const { data } = await getDetails();
    // 	setPlayoffs(data.playoffs);
    // };
    const updateProducts = (product)=>{
        let newProducts = [
            ...products
        ];
        let index = newProducts.findIndex((p)=>product.id === p.id);
        newProducts[index] = product;
        setProducts(newProducts);
    };
    const handleProductFavorite = async (product)=>{
        if (isAuthenticated) {
            let { product_favourite  } = product;
            let user = session.user;
            if (product_favourite.length) {
                let pf = product_favourite[0];
                pf.favourite = false;
                let res = await (0,service_products/* UpdateProductFavourite */.Wb)(pf);
                product.product_favourite = product.product_favourite.filter((product_favourite)=>pf.id !== product_favourite.id);
                updateProducts(product);
            } else {
                let res1 = await (0,service_products/* CreateProductFavourite */.sx)({
                    product: product.id,
                    faved_by: user.id,
                    m_list: grapeList.id
                });
                product.product_favourite = [
                    res1.data
                ];
                updateProducts(product);
            }
        } else {
            setAuthOpen(true);
        }
    };
    const handleProductViews = async (product)=>{
        let { product_views  } = product;
        window.open(product.affiliated_url ? product.affiliated_url : product.url, "_blank", "noreferrer");
        if (product_views.length) {
            let product_view = product_views[0];
            product_view.views += 1;
            let res = await (0,service_products/* UpdateProductView */.I)(product_view);
            product.product_views[0] = res.data;
        // updateProducts(product);
        } else {
            let input_data = {
                product: product.id
            };
            if (isAuthenticated) {
                let user = session.user;
                input_data.viewed_by = user.id;
            } else {
                let currentUser = (0,index_esm/* getAuth */.v0)().currentUser;
                input_data.uid = currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid;
            }
            let res1 = await (0,service_products/* CreateProductView */.E9)(input_data);
            product.product_views = [
                res1.data
            ];
        // updateProducts(product);
        // window.open(product.url, "_blank", "noreferrer");
        }
    };
    const updateAnimationState = ()=>{
        setAnimationSeen(!animationSeen);
    };
    (0,react.useEffect)(()=>{
        if (data !== undefined) {
            const { featured_curations , active_playoff  } = data;
            setActive_playoff(active_playoff);
            // 	setFeatured_curations([]);
            // setCategories(categories);
            // setCurated_playoffs(curated_playoffs);
            setFeatured_curations(featured_curations);
            // setPlayoffs(playoffs);
            // setGrapeList(grapeList);
            // setPersistentList(persistentList);
            // setProducts(persistentList?.products);
            setShowLoadingScreen(false);
        }
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        // getLoadDetails();
        let isFirstLoad = JSON.parse(localStorage.getItem("isFirstLoad"));
        if (isFirstLoad == false) {
            setShowProductTour(false);
        } else {
            localStorage.setItem("isFirstLoad", false);
            setShowProductTour(false);
        }
        setTimeout(()=>{
        // checkSelectedCategories();
        }, 3000);
    }, []);
    const steps = [
        {
            selector: ".grapeLogo",
            style: {
                backgroundColor: "#9650FA",
                padding: 16
            },
            content: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        color: "white",
                        pt: "4px"
                    },
                    children: "Share, discover & shop fashion on Grape \uD83D\uDC9C"
                })
        },
        {
            selector: ".mainplayoffCard",
            style: {
                backgroundColor: "#9650FA",
                padding: 16
            },
            content: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        color: "white",
                        pt: "4px"
                    },
                    children: "Start by curating here"
                })
        },
        // {
        //   selector: '.discover',
        //   style:{
        // 	backgroundColor:"#9650FA",
        // 	padding:16
        //   },
        //   content: ()=>(<Typography variant="body2" sx={{color:"white",pt:"4px"}} >Discover curations by others here</Typography>)
        // },
        {
            selector: ".playoff",
            style: {
                backgroundColor: "#9650FA",
                padding: 16
            },
            content: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        color: "white",
                        pt: "4px"
                    },
                    children: "Curate more here"
                })
        },
        {
            selector: ".playoffCard0",
            style: {
                backgroundColor: "#9650FA",
                padding: 16
            },
            content: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        color: "white",
                        pt: "4px"
                    },
                    className: "actual-content",
                    children: "Tap to browse & shop"
                })
        }
    ];
    // Handle Curation Code  Start
    const handleListFavorite = async (curationId)=>{
        // let user = await getUser();
        if (status === "authenticated") {
            let user = session.user;
            let curation = featured_curations.find((item)=>item.id === curationId);
            if (curation === null || curation === void 0 ? void 0 : curation.user_list_favourites) {
                let obj = {
                    id: curation.user_list_favourites.id,
                    favourite: curation.user_list_favourites.favourite ? false : true,
                    faved_by: curation.user_list_favourites.faved_by
                };
                let res = await (0,Curation/* UpdateListFavourite */.ru)(obj, session);
                curation.user_list_favourites = null;
                curation.favourites_count -= 1;
            } else {
                let res1 = await (0,Curation/* CreateListFavourite */.zf)({
                    faved_by: user.id,
                    m_list: curationId
                }, session);
                curation.favourites_count += 1;
                curation.user_list_favourites = res1.data;
            }
            let index = featured_curations.findIndex((item)=>item.id == curationId);
            let new_curationsList = featured_curations.filter((curation)=>curation.id !== curationId);
            new_curationsList.splice(index, 0, curation);
            setFeatured_curations(new_curationsList);
        } else {
            setAuthOpen(true);
        }
        console.log("executed");
    };
    const handleCurationListFavorite = async (curationId)=>{
        if (status === "authenticated") {
            let user = session.user;
            let curation = curations.find((item)=>item.id === curationId);
            if (curation === null || curation === void 0 ? void 0 : curation.user_list_favourites) {
                let obj = {
                    id: curation.user_list_favourites.id,
                    favourite: curation.user_list_favourites.favourite ? false : true,
                    faved_by: curation.user_list_favourites.faved_by
                };
                let res = await (0,Curation/* UpdateListFavourite */.ru)(obj, session);
                curation.user_list_favourites = null;
                curation.favourites_count -= 1;
            } else {
                let res1 = await (0,Curation/* CreateListFavourite */.zf)({
                    faved_by: user.id,
                    m_list: curationId
                }, session);
                console.log(curation);
                curation.favourites_count += 1;
                curation.user_list_favourites = res1.data;
            }
            let index = curations.findIndex((item)=>item.id == curationId);
            let new_curationsList = curations.filter((curation)=>curation.id !== curationId);
            new_curationsList.splice(index, 0, curation);
            console.log(new_curationsList);
            setCurations(new_curationsList);
        } else {
            setAuthOpen(true);
        }
        console.log("executed");
    };
    const handleGrapeListFavorite = async (curationId)=>{
        if (status === "authenticated") {
            let user = session.user;
            let curation = grapeList.find((item)=>item.id === curationId);
            console.log(curation);
            if (curation.user_list_favourites) {
                let obj = {
                    id: curation.user_list_favourites.id,
                    favourite: curation.user_list_favourites.favourite ? false : true,
                    faved_by: curation.user_list_favourites.faved_by
                };
                let res = await (0,Curation/* UpdateListFavourite */.ru)(obj, session);
                curation.user_list_favourites = null;
                curation.favourites_count -= 1;
            } else {
                let res1 = await (0,Curation/* CreateListFavourite */.zf)({
                    faved_by: user.id,
                    m_list: curationId
                }, session);
                curation.favourites_count += 1;
                curation.user_list_favourites = res1.data;
            }
            let index = grapeList.findIndex((item)=>item.id == curationId);
            let new_curationsList = grapeList.filter((curation)=>curation.id !== curationId);
            new_curationsList.splice(index, 0, curation);
            console.log(new_curationsList);
            setGrapeList(new_curationsList);
        } else {
            setAuthOpen(true);
        }
    };
    // Handle Curation Code  end
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralHead/* default */.Z, {
                description: "",
                ogUrl: "www.grape.town",
                ogImage: "https://d2h50zujfkj84t.cloudfront.net/Grape1_91_1.jpg",
                ogTitle: "Grape | Your Shortcut to Fashion"
            }),
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeScreenSkeleton/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        pb: 8,
                        sx: {
                            backgroundColor: "background2.main"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* Header */.h, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "https://grape.onelink.me/dwuE/ker2b503s",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                sx: {
                                    textDecoration: "none",
                                    color: "rgba(0, 0, 0, 0.87)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        width: "100%",
                                        height: 40,
                                        background: "linear-gradient(270deg, #DDC4F5 2.94%, #CDF1F5 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        px: 2,
                                        justifyContent: "space-between"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: "GRAPE now on Play Store. Tap to download \uD83D\uDCF2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                            sx: {
                                                fontSize: 14
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    marginTop: 2.5,
                                    marginBottom: 2.75,
                                    marginX: 2.5
                                },
                                children: active_playoff ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: "mainplayoffCard",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayOffCard/* PlayOffCard */.U, {
                                        class: true,
                                        playoff: active_playoff
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivePlayoffSkeleton/* default */.Z, {
                                    firstCard: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    marginY: 3.128,
                                    marginX: 2.5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            textAlign: "center",
                                            textTransform: "capitalize"
                                        },
                                        mb: 1,
                                        children: "Featured Community Curations"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            fontWeight: 200,
                                            textAlign: "center"
                                        },
                                        mx: 2,
                                        mb: 3,
                                        children: "Browse & shop curations by others like you"
                                    }),
                                    featured_curations.length ? featured_curations.map((curation, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedCurationCard/* FeaturedCurationCard */.U, {
                                            type: "featured",
                                            handleListFavorite: handleListFavorite,
                                            home: true,
                                            curation: curation,
                                            scrollContainerRef: scrollContainerRef
                                        }, "playoff-".concat(i))) : Array.from(new Array(3)).map((item, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                marginRight: 0.5,
                                                my: 5
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurationCardSkeleton/* default */.Z, {})
                                        }, "curationSkeleton" + index);
                                    })
                                ]
                            }),
                            persistentList && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        py: 3.128,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: {
                                                    marginX: "auto"
                                                },
                                                mb: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* AnimationOnScroll */.n, {
                                                        initiallyVisible: true,
                                                        animateIn: "animate__zoomIn",
                                                        afterAnimatedOut: ()=>setAfterOutState((c)=>c + 1),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            component: "div",
                                                            variant: "h2",
                                                            sx: {
                                                                textAlign: "center",
                                                                textTransform: "capitalize",
                                                                mb: 1
                                                            },
                                                            children: persistentList.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        sx: {
                                                            fontWeight: 200,
                                                            textAlign: "center"
                                                        },
                                                        mx: 2,
                                                        mb: 3,
                                                        children: "Most popular products updated daily"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                container: true,
                                                spacing: 2,
                                                pt: 2,
                                                px: 2,
                                                children: persistentList.products ? (_persistentList_products = persistentList.products) === null || _persistentList_products === void 0 ? void 0 : _persistentList_products.slice(0, 4).map((product, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* ProductCard */.I, {
                                                        curation: persistentList,
                                                        product: product,
                                                        handleViews: handleProductViews,
                                                        session: session,
                                                        status: status,
                                                        setAuthOpen: setAuthOpen,
                                                        setOpen: setOpen,
                                                        setCurationsCount: setCurationsCount
                                                    }, "prod-" + i)) : Array.from(new Array(2)).map((item, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        xs: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSkeleton/* default */.Z, {})
                                                    }, "PersitentList" + index);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            typography: "altag",
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                            variant: "text",
                                            color: "primary",
                                            href: "/list/".concat(persistentList.slug),
                                            sx: {
                                                fontSize: "14px",
                                                lineHeight: "18px",
                                                textTransform: "initial"
                                            },
                                            children: [
                                                "See More",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                                    fontSize: "inherit"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    marginY: 3.128,
                                    marginX: 2.5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            textAlign: "center",
                                            textTransform: "capitalize"
                                        },
                                        mb: 1,
                                        children: "Browse Inhouse Curations"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            fontWeight: 200,
                                            textAlign: "center"
                                        },
                                        mx: 2,
                                        mb: 3,
                                        children: "Shopping guides by our team filled with on-trend products"
                                    }),
                                    grapeList.length > 0 ? grapeList.map((curation, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(HomeGrapeOfficailCard/* default */.Z, {
                                            handleListFavorite: handleGrapeListFavorite,
                                            curation: curation
                                        }, "playoff-".concat(i))) : Array.from(new Array(3)).map((item, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                marginRight: 0.5,
                                                my: 5
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GapeList_GrapeListSkeleton, {})
                                        }, "knfg" + index);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            typography: "altag",
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "atag",
                                            underline: "none",
                                            component: Link/* default */.Z,
                                            href: "/list",
                                            direction: "row",
                                            alignItems: "center",
                                            color: "primary",
                                            children: [
                                                "See More",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                                    fontSize: "inherit"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    marginY: 3.128,
                                    marginX: 2.5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            textAlign: "center",
                                            textTransform: "capitalize"
                                        },
                                        mb: 1,
                                        children: "Challenge Yourself"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            fontWeight: 200,
                                            textAlign: "center"
                                        },
                                        mx: 2,
                                        mb: 3,
                                        children: "Test your fashion sense with more curations"
                                    }),
                                    playoffs.length > 0 ? playoffs.slice(1).map((playoff, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            className: "playoffCard".concat(i),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayOffCard/* PlayOffCard */.U, {
                                                playoff: playoff,
                                                challengeSection: true
                                            }, "playoff-".concat(i))
                                        }, "playoff-".concat(i))) : Array.from(new Array(4)).map((item, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                marginRight: 0.5,
                                                my: 5
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivePlayoffSkeleton/* default */.Z, {
                                                challengeSection: true
                                            })
                                        }, "knff" + index);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            typography: "altag",
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "atag",
                                            underline: "none",
                                            component: Link/* default */.Z,
                                            href: "/playoff",
                                            direction: "row",
                                            alignItems: "center",
                                            color: "primary",
                                            children: [
                                                "More Playoffs",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                                    fontSize: "inherit"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                variant: "middle"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                ref: ref,
                                sx: {
                                    marginY: 5,
                                    marginX: 2.5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            textAlign: "center",
                                            textTransform: "capitalize"
                                        },
                                        pt: 2,
                                        mb: 3,
                                        children: "Curations by Category"
                                    }),
                                    categories.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList/* CategoryList */.o, {
                                        categoryList: categories,
                                        inView: inView
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                        direction: "row",
                                        component: Stack/* default */.Z,
                                        spacing: 2,
                                        sx: {
                                            display: "-webkit-box",
                                            overflowX: "scroll",
                                            msOverflowStyle: "none",
                                            scrollbarWidth: "none",
                                            "&::-webkit-scrollbar": {
                                                width: 0
                                            }
                                        },
                                        children: Array.from(new Array(4)).map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        animation: "wave",
                                                        variant: "circular",
                                                        width: 98,
                                                        height: 98
                                                    }, "playoffloader-".concat(index)),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                                                ]
                                            }, "cbc+".concat(index));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    marginY: 5,
                                    marginX: 2.5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            textAlign: "center",
                                            textTransform: "capitalize"
                                        },
                                        pt: 2,
                                        mb: 3,
                                        children: "Curations by PlayOff"
                                    }),
                                    curated_playoffs.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayoffList, {
                                        playoffList: curated_playoffs
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                        direction: "row",
                                        component: Stack/* default */.Z,
                                        spacing: 2,
                                        sx: {
                                            display: "-webkit-box",
                                            overflowX: "scroll",
                                            msOverflowStyle: "none",
                                            scrollbarWidth: "none",
                                            "&::-webkit-scrollbar": {
                                                width: 0
                                            }
                                        },
                                        children: Array.from(new Array(4)).map((item, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        animation: "wave",
                                                        variant: "circular",
                                                        width: 98,
                                                        height: 98
                                                    }, "playoffloader-".concat(index)),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                                                ]
                                            }, "cbp+".concat(index));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    marginY: 5,
                                    marginX: 2.5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            textAlign: "center",
                                            textTransform: "capitalize"
                                        },
                                        pt: 2,
                                        mb: 1,
                                        children: "Browse & Shop"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            fontWeight: 200,
                                            textAlign: "center"
                                        },
                                        mx: 2,
                                        mb: 3,
                                        children: "Streetwear, glam partywear or workwear, we’ve got you covered!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScorllContainer/* ScrollContainer */.l, {
                                        items: curations,
                                        emptyText: "No Curations",
                                        setItems: setCurations,
                                        APICallFunc: getCurations,
                                        page: pageDetail ? pageDetail.page : 2,
                                        session: session,
                                        children: curations.map((curation, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedCurationCard/* FeaturedCurationCard */.U, {
                                                curations: curations,
                                                home: true,
                                                handleListFavorite: handleCurationListFavorite,
                                                curation: curation,
                                                scrollContainerRef: scrollContainerRef
                                            }, "curations-".concat(i)))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyNameFooter/* default */.Z, {
                                required: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* BottomNavbar */.n, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tour, {
                        steps: steps,
                        isOpen: showProductTour,
                        onRequestClose: closeProductTour,
                        rounded: 8,
                        className: "productTour",
                        showNumber: false,
                        nextButton: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "NEXT"
                        }),
                        prevButton: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "PREV"
                        }),
                        disableInteraction: true,
                        lastStepNextButton: "FINISH",
                        disableFocusLock: true,
                        maskSpace: 3,
                        accentColor: "#FFF",
                        closeWithMask: false,
                        showNavigationNumber: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurationDrawer/* CurationDrawer */.G, {
                        setAuthOpen: setAuthOpen,
                        session: session,
                        status: status,
                        setOpen: setOpen,
                        open: open,
                        otherCurations: [],
                        setCurationsCount: setCurationsCount,
                        curationsCount: curationsCount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Index/* AuthDrawer */.v, {
                        setOpen: setAuthOpen,
                        open: authOpen
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,3662,2962,579,5665,3227,9332,6066,7044,9695,7653,9734,1585,6340,2178,6883,8149,5407,5299,4640,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);